
(function () {
  'use strict';

  function initConversion() {
    document.querySelectorAll('[data-cv-stock]').forEach(function (el) {
      var qty = parseInt(el.getAttribute('data-cv-stock'), 10);
      var threshold = parseInt(el.getAttribute('data-cv-threshold') || '8', 10);
      var label = el.querySelector('[data-cv-stock-label]');
      if (!Number.isFinite(qty) || !label || qty <= 0 || qty > threshold) return;

      label.textContent = qty === 1
        ? 'Only 1 left — order soon if you want this one.'
        : 'Only ' + qty + ' left — popular sizes can sell out.';
      el.classList.add('is-visible');
    });

    // Keeps the sticky purchase affordance visible only after the native
    // product form has scrolled away. This reduces mobile friction.
    var nativeForm = document.querySelector('.product-information .buy-buttons');
    var sticky = document.querySelector('[data-cv-sticky-cta]');
    if (!nativeForm || !sticky || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.15 });
    observer.observe(nativeForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConversion);
  } else {
    initConversion();
  }
})();
